(function (window, app, overwatch) {
    var patchNotes = {
        init: function() {
            window.overwatch.slideout.init();
            window.overwatch.tooltip.init();
            this.setupAnalytics();
        },
        setupAnalytics: function() {
            $(document.body).on("slideout:open", function(event, id) {
                if(window.dataLayer) {
					window.dataLayer.push({
						"event": "drawerOpen",
						"drawer": id
					});
				}
            });
        }
    };
    app.extend({
        patchNotes: patchNotes
    });
}(window, window.app, window.overwatch));
